import { usePageContent } from "@/hooks/usePageContent";
import { useProxyImage } from "@/hooks/useProxyImage";
import { useErrorToast } from "@/hooks/useErrorToast";
import { logClientErrorWithContext } from "@/lib/logger/src/logClientErrorWithContext";
import { useState } from "react";

export const useSignIn = () => {
  const { pageContent, status } = usePageContent("corp-welcomes");
  const welcomeMProxyUrl = useProxyImage(pageContent?.welcomeMImage); //change
  const welcomeInProxyUrl = useProxyImage(pageContent?.welcomeBgImage); //change to custom hook
  const [signInLoading, setSignInLoading] = useState(false);

  const handleClientApiError = useErrorToast();

  const handleSignIn = async () => {
    setSignInLoading(true);
    try {
      const eaaResp = await fetch("/api/auth/eaa");
      const data = await eaaResp.json();
      if (eaaResp.status !== 200 || !data.eaaRedirectUrl) {
        //throwing to catch on below catch block
        throw new Error("EAA login redirection failed");
      } else {
        window.location.assign(data.eaaRedirectUrl);
      }
    } catch (err) {
      logClientErrorWithContext({
        alertName: "QRV_CORP_ERROR_EAA",
        error: err,
        pageName: "useSignIn",
        apiName: "/api/auth/eaa",
        httpMethod: "GET",
        correlationId: "",
        operation: "",
        operationSignature: "",
        redirectTo: "/not-found"
      });
      handleClientApiError();
    }
  };

  const handleJoinFree = async () => {
    try {
      const eaaResp = await fetch("/api/auth/eaa-join");
      const data = await eaaResp.json();
      if (eaaResp.status !== 200 || !data.eaaRedirectUrl) {
        throw new Error("EAA Register redirection failed");
      } else {
        //opening URL in new tab window
        window.open(data.eaaRedirectUrl, "_blank");
      }
    } catch (err) {
      logClientErrorWithContext({
        alertName: "QRV_CORP_ERROR_EAA",
        error: err,
        pageName: "useSignIn",
        apiName: "/api/auth/eaa-join",
        httpMethod: "GET",
        correlationId: "",
        operation: "",
        operationSignature: "",
        redirectTo: "/not-found"
      });
      handleClientApiError();
    }
  };

  return {
    signInLoading,
    pageContent,
    status,
    handleSignIn,
    handleJoinFree,
    welcomeMProxyUrl,
    welcomeInProxyUrl,
  };
};
